import { render } from "./CreateVMFromBackup.vue?vue&type=template&id=38c21281&scoped=true"
import script from "./CreateVMFromBackup.vue?vue&type=script&lang=js"
export * from "./CreateVMFromBackup.vue?vue&type=script&lang=js"

import "./CreateVMFromBackup.vue?vue&type=style&index=0&id=38c21281&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c21281"]])

export default __exports__